import { Component, OnInit, AfterViewInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { AfFlag, AFNavigation, AF_CONSTANTS } from "../model/af.model";
import { AuthService } from '../service/auth.service';
import { EventService } from '../service/event.service';
import { ChangeLoginEvent, ChangeNavigationEvent, ConsumerPrivacyActEvent, SkipToMainContentEvent, SkipToTopContentEvent } from "../service/events";

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
  standalone: false
})

export class NavigationComponent implements OnInit, AfterViewInit {
  afFlag: AfFlag;
  navId: number = 0;
  reRender: boolean = false;
  eventBus: EventService;
  navList: Array<AFNavigation>;
  public _router: Router;
  currentUrl: string;
  actionSection: boolean = false;
  tabIndexOmit: boolean = false;
  navChange: boolean = false;
  mobile: boolean = false;

  constructor(private readonly authService: AuthService, eventBus: EventService, router: Router) {
    this.eventBus = eventBus;
    this._router = router;
  }

  onClickNavigationLink(nav: any) {
    if (nav.id < this.navId) {
      this.selectedNavItem(nav.id);
      sessionStorage.setItem('maxNavigation', this.navId.toString());
      this._router.navigate([nav.routerLink]);
    }
  }

  ngOnInit() {
    this.handleNav();

    this.eventBus.on(
      ChangeNavigationEvent,
      (event): void => {
        this.navList = this.authService.getNavLinks();
        let maxNavigationValue: string = sessionStorage.getItem('maxNavigation');
        if (Number(maxNavigationValue) > event.payload.id) {
          sessionStorage.setItem('maxNavigation', event.payload.id.toString());
        }
        this.selectedNavItem(event.payload.id);
      }
    );

    this.eventBus.on(
      ChangeLoginEvent,
      (): void => {
        this.selectedNavItem(0);
      }
    );

    this.eventBus.on(
      ConsumerPrivacyActEvent,
      (): void => {
        setTimeout(() => {
          this.navList = this.authService.getNavLinks();
        }, 100);
      }
    );

    this.eventBus.on(
      SkipToMainContentEvent,
      (event): void => {
        if (event.payload.text) {
          if (event.payload.text == "FocusOff") {
            this.tabIndexOmit = false;
          } else {
            this.tabIndexOmit = true;
          }
        }
      }
    );

  }

  @HostListener('window:resize', ['$event'])
  @HostListener('window:load', ['$event'])
  handleNav() {
    const windowWidth = window.innerWidth;
    if (windowWidth <= AF_CONSTANTS.windowWidth) {
      this.navChange = true;
    } else {
      this.navChange = false;
    }

    if (windowWidth <= 768) {
      this.mobile = true;
    } else {
      this.mobile = false;
    }
  }

  ngAfterViewInit() {
    this._router.events.subscribe(
      (): void => {
        this.currentUrl = this._router.url;
        if (this.authService.getNavLinks() != null) {
          this.actionSection = this.authService.getNavLinks().find(e => e.routerLink === this.currentUrl) != null;
          this.eventBus.emit(new SkipToTopContentEvent({}));
        }
      }
    );
  }

  keyDown(nav: any) {
    this.onClickNavigationLink(nav);
    this._router.navigate([nav.routerLink]);
  }

  lessThan(nav: number) {
    if (nav < this.navId) {
      return true;
    } else {
      return false;
    }
  }

  selectedNavItem(navId: number) {
    if (navId != this.navId) {
      this.navId = navId;
    }
  }
}
